import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// types
import { TEventsList, TEventsListPoppper } from 'redux-store/types';
import { CalendarViewModeEnum } from 'pages/project-dashboard/sections/schedule/sections/calendar/utils/types';

export interface IScheduleModalsSlice {
  eventsListPoppper: TEventsListPoppper;
  forceUpdateProject: boolean;
  eventsList: TEventsList;
  calendarMode: CalendarViewModeEnum;
}

const initialState: IScheduleModalsSlice = {
  eventsListPoppper: { isOpen: false, x: null, y: null },
  forceUpdateProject: false,
  eventsList: null,
  calendarMode: CalendarViewModeEnum.MONTH,
};

export const calendarViewSlice = createSlice({
  name: 'calendar-view',
  initialState,
  reducers: {
    setEventsListPoppperProps: (state, action: PayloadAction<TEventsListPoppper>) => {
      state.eventsListPoppper = action.payload;
    },

    setEventsList: (state, action: PayloadAction<TEventsList>) => {
      state.eventsList = action.payload;
    },

    setAllowUpdateProject: (state, action: PayloadAction<boolean>) => {
      state.forceUpdateProject = action.payload;
    },

    setCalendarMode: (state, action: PayloadAction<CalendarViewModeEnum>) => {
      state.calendarMode = action.payload;
    },
  },
});

export const { setEventsListPoppperProps, setEventsList, setAllowUpdateProject, setCalendarMode } =
  calendarViewSlice.actions;

export default calendarViewSlice.reducer;
